import React from 'react'

const Lifeandlove = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Match the words with their meanings.</p>
        <p>a. exhausted ------ tired</p>
        <p>b. apparent ------ clear</p>
        <p>c. vista ------ vision</p>
        <p>d. undulating ------ wavy</p>
        <p>e. destined ------ predetermined</p>
        <p>f. stuffy ------ suffocating, airless</p>
        <p>g. restrain ------ prevent, hinder</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Write the meaning and word class of the following words. Then use them in sentences of your own.</p>
        <p><strong>implore (Verb): </strong>To beg someone earnestly or desperately to do something.</p>
        <p>I implore you to reconsider your decision before it's too late.</p>
        <p><strong>despair ( Noun): </strong>A feeling of complete loss of hope.</p>
        <p>After losing his job, he was filled with despair but slowly started to look for new opportunities.</p>
        <p><strong>Beseech (Verb): </strong>To urgently and fervently ask or beg someone for something.</p>
        <p>I beseech you to help me with my project before the deadline.</p>
        <p><strong>Eloquent (Adjective): </strong>Fluent, persuasive, and expressive in speaking or writing.</p>
        <p>The speaker gave an eloquent speech that moved everyone in the audience.</p>
        <p><strong>whirl (Verb): </strong>To spin or rotate rapidly.</p>
        <p>The leaves began to whirl in the wind during the storm.</p>
        <p><strong>egoism (Noun): </strong>The practice of putting one's own interests and needs above those of others; excessive self-interest.</p>
        <p>His egoism made it difficult for him to work well with others on the team.</p>
        <p><strong>agony (Noun): </strong>Extreme physical or mental pain or suffering.</p>
        <p>She was in agony after twisting her ankle during the game.</p>
        <p><strong>delirious (Adjective): </strong>In a disturbed state of mind due to illness or excitement, often characterized by confusion or hallucinations.</p>
        <p>After running the marathon, he was so exhausted that he became delirious and could barely speak clearly.</p>
        <p><strong>delusive (Adjective): </strong>Giving a false or misleading impression; deceptive.</p>
        <p>His hopes of winning the lottery were delusive and not based on any realistic chance.</p>
        <p><strong>compensate (Verb): </strong>To give something, usually money, in recognition of loss, suffering, or work done.</p>
        <p>The company agreed to compensate the workers for the extra hours they had worked.</p>
        <p><strong>mortgage (Noun): </strong>A loan to buy property, paid back over time.</p>
        <p>She applied for a mortgage to purchase her new home.</p>
        <p><strong>brood (Verb): </strong>To think deeply and worry about something.</p>
        <p>He sat alone, brooding over his past mistakes.</p>
        <p><strong>prelude (Noun): </strong>An introduction or something that comes before an important event.</p>
        <p>The sudden drop in temperature was a prelude to the heavy snowfall.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>D. Choose the correct word.</p>
        <p>a. Sarita was shocking/<strong> shocked</strong> to hear about earthquake.</p>
        <p>b. I think that rainy days in winter are <strong>depressing</strong> /depressed.</p>
        <p>c. The football match was very <strong>exciting</strong> /excited. I enjoyed it.</p>
        <p>d. The meals at Delight Café are <strong>satisfying</strong> /satisfied.</p>
        <p>e. I've got nothing to do. I'm boring/ <strong>bored</strong>.</p>
        <p>f. Tanka is very good at telling funny stories. He can be very <strong>amusing</strong> /amused.</p>
        <p>g. The teacher's explanation was <strong>confusing</strong> /confused. Most of the students didn't understand it.</p>
        <p>h. He is such a <strong>boring</strong> /bored person. He never wants to go out.</p>
        <p>i. I will be surprising/ <strong>surprised</strong> if she does well in her test.</p>
        <p>j. Are you interesting/ <strong>interested</strong> in politics?</p>
      </div>
      <hr/>
      <div>
        <p className='question'>E. Write the correct form of the adjective in the blanks as in the example.</p>
        <p>a. They frustrate me but they don't bore me. I never get <u>bored</u> when I study grammar.</p>
        <p>b. If teachers want to interest the students, they must use <u>interesting</u> materials.</p>
        <p>c. Certain stories interest almost everybody. For example, most students are <u>interested</u> in fairy tales.</p>
        <p>d. Certain things frighten me, but I never get <u>frightened</u> when I speak English.</p>
        <p>e. If I get a good grade, that excites me. And if I get more than ninety percent, I am really <u>excited</u>.</p>
      </div>
      <hr/>
      <div>
        <h3>Understanding the text</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. Who was Nellie? What did she use to dream of?</p>
        <p>= Nellie was a young and pretty girl, the daughter of a landowner and a general. She used to dream of getting married and living a happy and peaceful life with her future husband.</p>
        <p className='question'>b. What was she doing with the looking glass?</p>
        <p>= She was staring into the looking glass with tired, half-closed eyes, imagining herself as a wife and mother, lost in her daydreams about the future.</p>
        <p className='question'>c. Why did she go to the doctor on one winter night?</p>
        <p>= She went to the doctor on one winter night because her husband had fallen seriously ill and needed immediate medical attention.</p>
        <p className='question'>d. What was Stepan Lukitch doing when she reached his bedroom?</p>
        <p>= Stepan Lukitch was lying in his bed, coughing and shivering with a fever, clearly unwell himself when she reached his bedroom.</p>
        <p className='question'>e. Why was the doctor not ready to go to see her husband?</p>
        <p>= The doctor was not ready to go to see her husband because he was extremely exhausted and sick himself after treating typhus patients continuously for the past three days.</p>
        <p className='question'>f. Why did Stepan Lukitch suggest Nellie to go to the Zemstvo doctor?</p>
        <p>= Stepan Lukitch suggested Nellie to go to the Zemstvo doctor because he was too ill to travel and believed the Zemstvo doctor might be able to help her husband immediately.</p>
        <p className='question'>g. Nellie said, “Come, perform that heroic deed! Have pity on us!" What was that pity to be done?</p>
        <p>= The pity to be done was for the doctor to gather the strength to visit and treat Nellie's seriously ill husband despite being sick himself.</p>
        <p className='question'>h. When Nellie said, "I must have fallen asleep." What does it mean?</p>
        <p>= It means that Nellie realized she had been lost in her imaginary world, and now she was waking up to face the harsh realities of real life.</p>
        <p className='question'>i. What is the main theme of the story?</p>
        <p>= The main theme of the story is the contrast between romantic dreams and harsh reality, highlighting devotion, loneliness, fear, and the emotional strength a person gains when facing real-life challenges.</p>
      </div>
      <hr/>
      <div>
        <h3>Critical thinking</h3>
        <p className='question'>a. “The looking glass (mirror)” is used as a symbol in the story. What does it symbolise?</p>
        <p>= In the story, the looking glass (mirror) symbolizes Nellie's desire for love and marriage, as well as her tendency to escape reality by imagining a romantic and idealized future. It reflects her inner world of dreams and fantasies, contrasting with the harsh realities she later faces.</p>
        </div>
        <hr/>
        <div>
        <p className='question'>b. Chekhov employs the magic trick in the story, using a very elegant transition from reality to imagination to reality sequence. Discuss its relevance to the life of young people.</p>

        <p>= Chekhov's use of the seamless shift between reality and imagination in The Looking Glass reflects how young people often escape into dreams and fantasies to cope with their everyday lives. Just like Nellie imagines herself as a princess and her husband as a prince charming, young people frequently dramatize life and romanticize love, sometimes exaggerating their emotions and experiences. This fairy-tale quality mirrors how youth tend to see the world with heightened feelings and idealism.</p>

        <p>Additionally, the story shows that this tendency to blur reality and imagination is not limited to young people but is a part of human nature. Both young and old can become caught up in fantasies, especially in today's world where social media and sensational news often distort reality. Chekhov's elegant transition invites readers to understand the importance of balancing dreams with reality, a lesson particularly relevant for young people learning to face life's challenges.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Match the expressions with their functions.</p>
        <p>a. A: What do you want to take?</p>
        <p>B: I'll have tea, please.</p>
        <p>Deciding</p>
        <br/>
        <p>b. A: Are you free this evening?</p>
        <p>B: No, I'm going to meet my uncle.</p>
        <p>Expressing a prior plan</p>
        <br/>
        <p>c. The day will be lovely tomorrow.</p>
        <p>Predicting a future action</p>
        <br/>
        <p>d. There is no cloud in the sky.</p>
        <p>It's going to be a lovely day.</p>
        <p>Predicting with evidence</p>
        <br/>
        <p>e. Don't worry. I won't tell anyone.</p>
        <p>Promising</p>
        <br/>
        <p>f. I'll take you to the movies if you like.</p>
        <p>Offering</p>
        <br/>
        <p>g. I'll tell your parents what you did.</p>
        <p>Threatening</p>
      </div>
      <hr/> 
      <div>
        <p className='question'>C. Choose the correct answer.</p>
        <p>a. A: Are you busy this evening?</p>
        <p>B: Yes, I <u>am going to</u> the movies. (will go/am going to)</p>
        <p>b. A: Where are you going for holiday this summer?</p>
        <p>B: Not sure yet. Maybe I <u>will go</u> to Ilam. (will go/am going to)</p>
        <p>c. I think you <u>will</u> like this movie. (will /are going to)</p>
        <p>d. I can't join you at the party, I <u>am going to</u> be away for two weeks. (will /am going to)</p>
        <p>e. This exercise looks really hard. I <u>will</u> help you. (will/am going to)</p>
        <p>f. A: Hello. Can I speak to Sima, please?</p>
        <p>B: Just a minute. I <u>will</u> get her. (will/am going to)</p>
        <p>g. Perhaps she <u>will</u> pass the exam. (will/is going to)</p>
        <p>h. 'I haven't got my phone.' 'That's OK. I will lend you mine.' (will/am going to)</p>

      </div>
      <hr/> 
      <div>
        <p className='question'>D. Complete the sentences using will or be going to with the verbs.</p>
        <p>a. Hari: Did you call Bina?</p>
        <p>Prem: Oh, I forgot. I <u>will call</u> her now. (call)</p>
        <p>b. Sunita: Have you got a ticket for the play?</p>
        <p>Hema: Yes, I <u>am going to watch</u> it on Saturday. (watch)</p>
        <p>c. 'The alarm is ringing. It's making an awful noise.' 'OK, I <u>will switch</u> it off.' (switch)</p>
        <p>d. Do you think they <u>will like</u> the the presents we got for them? (like)</p>
        <p>e. 'Lok is starting university tomorrow.' 'What <u>is he going to</u> study?'(he/study)</p>
        <p>f. If I meet him, I <u>will tell</u> him the news. (tell)</p>
        <p>g. The phone is ringing. I <u>will answer</u> it. (answer)</p>
        <p>h. If you don't stop bullying her, I <u>will tell</u> the teacher. (tell)</p>
      </div>
    </div>
  )
}

export default Lifeandlove
